import { render, staticRenderFns } from "./activity_speaker.vue?vue&type=template&id=b02de83e&scoped=true&"
import script from "./activity_speaker.vue?vue&type=script&lang=js&"
export * from "./activity_speaker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b02de83e",
  null
  
)

export default component.exports